<ngx-spinner></ngx-spinner>

<ng-template #altaActualizacionTareaAdministrador let-c="close" let-d="dismiss">
  <div class="modal-header" style="margin-top: -10px">
    <h5 class="modal-title">{{ tarea.IdTarea != null ? 'Actualizar Tarea' : 'Crear Tarea'}}</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-actions">
      <div class="row" style="margin-top: -10px">
        <div class="col-md-4">
          <div class="form-group">
            <label for="projectinput1" style="font-size: 8pt;">Titulo *</label>
            <input type="text" id="projectinput1" class="form-control" name="titulotarea" placeholder="Titulo tarea"
              (keydown.enter)="$event.preventDefault()" [(ngModel)]="tarea.TituloTarea" maxlength="40" [ngClass]="{ 'is-invalid': errorTitulo,
                    'is-valid': tarea.TituloTarea != null && tarea.TituloTarea != '' && !errorTitulo }"
              (blur)="validarTituloTarea()">

            <div *ngIf="errorTitulo" class="help-block mt-1 text-danger"> <i
                class="fas fa-exclamation-circle align-middle"></i>
              Escribe el titulo
            </div>
          </div>
        </div>

        <div class="col-md-8">
          <div class="form-group">
            <label for="projectinput1" style="font-size: 8pt;">Descripción *</label>
            <textarea class="form-control" [(ngModel)]="tarea.DescripcionTarea" name="descripciontarea" maxlength="500"
              placeholder="Descripcion de la tarea" (keydown.enter)="$event.preventDefault()"
              [ngClass]="{ 'is-invalid': errorDescripcion,
                      'is-valid': tarea.DescripcionTarea != null && tarea.DescripcionTarea != '' && !errorDescripcion }" (blur)="validarDescripcion()">
              </textarea>

            <div *ngIf="errorDescripcion" class="help-block mt-1 text-danger"> <i
                class="fas fa-exclamation-circle align-middle"></i>
              Escribe la descripción de la tarea
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="projectinput1" style="font-size: 8pt;">Prioridad *</label>
            <select class="form-control" style="font-size: 8pt; width: 200px;" #prioridadSelect
              [(ngModel)]="tarea.Prioridad" [ngModelOptions]="{standalone: true}">
              <option *ngFor="let prioridad of listaPrioridad" [value]="prioridad.Prioridad">
                {{prioridad.PrioridadTexto}}</option>
            </select>

            <div *ngIf="errorPrioridad" class="help-block mt-1 text-danger"> <i
                class="fas fa-exclamation-circle align-middle"></i>
              Selecciona una prioridad
            </div>
          </div>

          <div class="form-group" *ngIf="tarea.IdTarea != null">
            <label for="projectinput1" style="font-size: 8pt;">Estatus *</label>
            <select class="form-control" style="font-size: 8pt; width: 200px;" #prioridadSelect
              [(ngModel)]="tarea.IdEstatusTarea" [ngModelOptions]="{standalone: true}">
              <option *ngFor="let estatus of listaEstatusTarea" [value]="estatus.IdEstatusTarea">{{estatus.Descripcion}}
              </option>
            </select>

          </div>
        </div>

        <div class="col-md-9">
          <div class="form-group">

            <table style="margin-top: -10px;">
              <tr>
                <td>
                  <label for="projectinput1" style="margin-right: 50px;">Asignar a: </label>
                </td>
                <td>
                  <label for="ngx-filter-ref">Buscar Empleado:
                    <input class="form-control form-control-sm d-inline-block" style="width: 250px" type="text"
                      placeholder="Por Nombre" (keyup)="NombreEmpleadoFiltro($event)" />
                  </label>
                </td>
              </tr>
            </table>

            <!-- <label for="projectinput1">Asignar a: </label> -->

            <table class="table table-responsive-md text-center">
              <thead>
                <tr>
                  <th>Nombre Empleado</th>
                  <th>Perfil</th>
                  <th>Asignar</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let usuario of listaUsuarioDirigido; let i=index">
                  <td>
                    <div style="text-align: left; margin-left: 15px;">
                      <label style="font-size: 10pt;">{{usuario.NombreCompleto}}</label>
                    </div>
                  </td>
                  <td>
                    <div style="text-align: left; margin-left: 15px;">
                      <label style="font-size: 10pt;">{{usuario.Perfil}}</label>
                    </div>
                  </td>
                  <td>
                    <ui-switch class="ml-1" size="small" (change)="seleccionoUsuario($event, usuario)"
                      [checked]="usuario.seleccionado == true"></ui-switch>
                  </td>
                </tr>
                <tr *ngIf="listaUsuarioDirigido.length == 0" role='row'>
                  <td colspan="3" class="paddingarriaba80 text-center">Sin registros que mostrar</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div style="height: 150px;"></div>

    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary btn-sm btn-save" (click)="agregaroactualizartarea()" style="font-size: 8pt;">
      {{ tarea.IdTarea != null ? 'Actualizar Tarea' : 'Crear Tarea'}}
    </button>
    <button type="button" class="btn btn-secondary btn-sm btn-raised" (click)="c('Close click')"
      style="font-size: 8pt;">Close</button>
  </div>
</ng-template>

<ng-template #altaNotaTarea let-c="close" let-d="dismiss">
  <div class="modal-header" style="margin-top: -10px">
    <h5 class="modal-title">Notas</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-actions">
      <div class="row" style="margin-top: -10px">
        <div class="col-md-12">
          <div class="table-wrapper-scroll-y my-custom-scrollbar" style="margin-bottom: -10px;">
            <div style="height: 35vh; overflow-y: auto;">
              <table class="table table-responsive-md text-center">
                <thead style="font-size: 10pt">
                  <tr>
                    <th>Usuario</th>
                    <th>Nota</th>
                    <th>Fecha Registro</th>
                    <th>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let tareaXNotas of TareaSeleccionada.TareasXNotas; let i=index">
                    <td style="text-align: left;">
                      <label style="font-size: 8pt;">{{tareaXNotas.Usuario}}</label>
                    </td>
                    <td style="text-align: left;">
                      <label style="font-size: 8pt;">{{tareaXNotas.Nota}}</label>
                    </td>
                    <td>
                      <label style="font-size: 8pt;">{{tareaXNotas.FechaRegistro | date:'dd/MM/yyyy'}}</label>
                    </td>
                    <td>
                      <a class="danger" data-toggle="tooltip" (click)="eliminarNota(tareaXNotas)" data-placement="top"
                        title="Eliminar Nota">
                        <i class="fas fa-trash font-medium-3"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 15px; margin-bottom: -20px;">
        <div class="col-md-12">
          <div class="form-group">
            <label for="projectinput1" style="font-size: 8pt;">Nota o comentario *</label>
            <textarea class="form-control" [(ngModel)]="notaNueva" name="nota" maxlength="250" style="font-size: 8pt;"
              placeholder="Escribe tu nota o comentario" (keydown.enter)="$event.preventDefault()">
              </textarea>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 10px; width: 100%; justify-content: center;">
        <button class="btn btn-primary btn-sm btn-save" (click)="agregarNota()" style="font-size: 8pt;">
          Agregar Nota
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm btn-raised" (click)="c('Close click')"
      style="font-size: 8pt;">Close</button>
  </div>
</ng-template>

<ng-template #altaDocumentosTarea let-c="close" let-d="dismiss">
  <div class="modal-header" style="margin-top: -10px">
    <h5 class="modal-title">Documentos</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-actions">
      <div class="row" style="margin-top: -10px">
        <div class="col-md-12">
          <div class="table-wrapper-scroll-y my-custom-scrollbar" style="margin-bottom: -10px;">
            <div style="height: 35vh; overflow-y: auto;">
              <table class="table table-responsive-md text-center">
                <thead style="font-size: 10pt">
                  <tr>
                    <th>Usuario</th>
                    <th>Nota</th>
                    <th>Documento</th>
                    <th>Url</th>
                    <th>Fecha Registro</th>
                    <th>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let documento of TareaSeleccionada.TareasXDocumento; let i=index">
                    <td>
                      <label style="font-size: 8pt;">{{documento.Usuario}}</label>
                    </td>
                    <td>
                      <label style="font-size: 8pt;">{{documento.Nota}}</label>
                    </td>
                    <td>
                      <label style="font-size: 8pt;">{{documento.NombreDocumento}}</label>
                    </td>
                    <td>
                      <a [href]="documento.UrlArchivo" target="_blank">Link</a>
                    </td>
                    <td>
                      <label style="font-size: 8pt;">{{documento.FechaRegistro | date:'dd/MM/yyyy'}}</label>
                    </td>
                    <td>
                      <a class="danger" data-toggle="tooltip" (click)="eliminarDocumento(documento)"
                        *ngIf="TareaSeleccionada.IdUsuarioCreaTarea == authService.usuarioConectado.Usuario.IdUsuario"
                        data-placement="top" title="Eliminar Documento">
                        <i class="fas fa-trash font-medium-3"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 10px">
        <div class="col-lg-4">
          <div>Selecciona multiples archivos</div>
          <input #file type="file" (change)="onSelectFile(file, file.files)" [multiple]="'multiple'"
            [accept]="'.jpg, .png, .gif, .jpeg, .pdf, .ts, .cs, .docx, .xlsx, .pptx'" />
          <div class="form-group" style="margin-top: 50px">
            <label for="projectinput1" style="font-size: 8pt;">Nota o comentario *</label>
            <textarea class="form-control" [(ngModel)]="tareaXDocumentoAgregar.Nota" name="nota" maxlength="250"
              style="font-size: 8pt;" placeholder="Escribe tu nota o comentario"
              (keydown.enter)="$event.preventDefault()">
            </textarea>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="table-wrapper-scroll-y my-custom-scrollbar" style="margin-bottom: -10px;">
            <div style="height: 35vh; overflow-y: auto;">
              <table class="table table-responsive-md text-center">
                <thead style="font-size: 10pt">
                  <tr>
                    <th>Documento</th>
                    <th>Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let documento of selectedFiles; let i=index">
                    <td>
                      <label style="font-size: 8pt;">{{documento?.name}}</label>
                    </td>
                    <td>
                      <a class="danger" data-toggle="tooltip" (click)="eliminarDocumentoTemporal(documento)"
                        data-placement="top" title="Eliminar Documento">
                        <i class="fas fa-trash font-medium-3"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary btn-sm btn-save" (click)="agregarArchivos()" style="font-size: 8pt;"
      [disabled]="selectedFiles.length == 0">
      Agregar Archivos
    </button>
    <button type="button" class="btn btn-secondary btn-sm btn-raised" (click)="cerrarArchivos()"
      style="font-size: 8pt;">Close</button>
  </div>
</ng-template>

<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12" style="margin-top: -10px;">
      <div class="card">
        <div class="card-content">
          <div class="card-body">

            <fieldset class="form-group" style="margin-top: -20px; margin-bottom: 0px;">
              <table style="width: 100%;">
                <tr>
                  <td style="width: 40%;">
                    <table>
                      <tr>
                        <td>
                          <label for="ngx-filter-ref" style="font-size: 8pt;">Buscar:
                            <input class="form-control form-control-sm d-inline-block" maxlength="50"
                              [(ngModel)]="busquedaTarea" style="width: 200px; font-size: 8pt; margin-right: 10px;"
                              type="text" placeholder="Por Titulo" (keyup)="buscarTareas($event)" />
                          </label>
                        </td>
                        <td>
                          <button type="button" (click)="agregarOEditarTarea(altaActualizacionTareaAdministrador, null)"
                            class="btn btn-sm mr-1 btn-raised btn-primary"
                            style="font-size: 8pt; vertical-align: super; margin-right: 5px;">
                            Agregar Tarea
                          </button>
                        </td>
                        <td>
                          <button type="button" (click)="verGraficasTareas()"
                            class="btn btn-sm mr-1 btn-raised btn-warning"
                            style="font-size: 8pt; vertical-align: super;">
                            Ver Graficas
                          </button>
                        </td>
                      </tr>
                    </table>
                  </td>

                  <td style="width: 25%;" *ngIf="!tieneFiltro">
                    <div style="margin-top: 5px;">
                      <ngb-pagination [collectionSize]="TotalRegistros" [(page)]="pagina" [pageSize]="limitRef"
                        [maxSize]="4" [rotate]="true" [boundaryLinks]="true" size="sm"
                        (pageChange)="cambioPagina($event, limitRef)"></ngb-pagination>
                    </div>
                  </td>

                  <td style="width: 25%;" *ngIf="!tieneFiltro">
                    <label class="float-right" style="font-size: 8pt">Mostrar
                      <select name="users-list-select"
                        class="form-control form-control-sm d-inline-block width-100 p-right-25 pl-4 mx-1"
                        style="font-size: 8pt" (change)="updateLimit($event)">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      registros <label *ngIf="TotalRegistros > limitRef">de
                        {{TotalRegistros}}</label>
                    </label>
                  </td>
                </tr>
              </table>


              <table *ngIf="verGraficas">
                <tr>
                  <td>
                    <label for="ngx-filter-ref" style="font-size: 8pt;">Buscar:
                      <input class="form-control form-control-sm d-inline-block" maxlength="50"
                        [(ngModel)]="busquedaTarea" style="width: 200px; font-size: 8pt; margin-right: 10px;"
                        type="text" placeholder="Por Titulo" (keyup)="buscarTareas($event)" />
                    </label>
                  </td>
                  <td>
                    <button type="button" (click)="agregarOEditarTarea(altaActualizacionTareaAdministrador, null)"
                      class="btn btn-sm mr-1 btn-raised btn-primary"
                      style="font-size: 8pt; vertical-align: super; margin-right: 5px;">
                      Agregar Tarea
                    </button>
                  </td>
                  <td>
                    <button type="button" (click)="verTareas()" class="btn btn-sm mr-1 btn-raised btn-danger"
                      style="font-size: 8pt; vertical-align: super;">
                      Ver Tareas
                    </button>
                  </td>
                </tr>
              </table>
            </fieldset>

            <!-- [style.display] = "verGraficas == false ? 'none' : ''" -->
            <div class="row" style="margin-top: 10px" [style.display]="verGraficas == false ? 'none' : ''">
              <div class="col-xl-6 col-sm-6 col-12">

                <h4 class="card-title">Tareas en el año {{year}}</h4>

                <apx-chart #chart1 [series]="tareasEnElAnoOptions?.series" [chart]="tareasEnElAnoOptions?.chart"
                  [dataLabels]="tareasEnElAnoOptions?.dataLabels" [plotOptions]="tareasEnElAnoOptions?.plotOptions"
                  [xaxis]="tareasEnElAnoOptions?.xaxis" [stroke]="tareasEnElAnoOptions?.stroke"
                  [fill]="tareasEnElAnoOptions?.fill" [yaxis]="tareasEnElAnoOptions?.yaxis"
                  [title]="tareasEnElAnoOptions?.title" [tooltip]="tareasEnElAnoOptions?.tooltip"
                  [legend]="tareasEnElAnoOptions?.legend">
                </apx-chart>
              </div>
              <div class="col-xl-6 col-sm-6 col-12">

                <h4 class="card-title">Tareas por prioridad</h4>

                <apx-chart #chart2 [series]="tareasPorPrioridad?.series" [chart]="tareasPorPrioridad?.chart"
                  [dataLabels]="tareasPorPrioridad?.dataLabels" [plotOptions]="tareasPorPrioridad?.plotOptions"
                  [xaxis]="tareasPorPrioridad?.xaxis" [stroke]="tareasPorPrioridad?.stroke"
                  [fill]="tareasPorPrioridad?.fill" [yaxis]="tareasPorPrioridad?.yaxis"
                  [title]="tareasPorPrioridad?.title" [tooltip]="tareasPorPrioridad?.tooltip"
                  [legend]="tareasPorPrioridad?.legend">
                </apx-chart>
              </div>
            </div>

            <div class="table-wrapper-scroll-y my-custom-scrollbar" [style.margin-top]="tieneFiltro ? '5px' : '-10px'"
              style="margin-left: -15px; height: 62vh; overflow-y: auto;">
              <table class="table table-responsive-md text-center">
                <thead style="font-size: 10pt; text-align: left;">
                  <tr>
                    <th>Nombre</th>
                    <th>Perfil</th>
                    <th style="background-color: '#827397'">Nuevas</th>
                    <th style="background-color: '#4D4C7D'">En Proceso</th>
                    <th style="background-color: '#363062'">Terminadas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="rows.length == 0" role='row'>
                    <td colspan="6" class="paddingarriaba80 text-center">Sin registros</td>
                  </tr>
                  <ng-container *ngFor="let usuario of rows; let i=index">
                    <tr *ngIf="usuario.usuario.EsVisible">
                      <td style="font-size: 8pt; text-align: left;">
                        {{usuario.usuario.NombreCompleto}}
                      </td>
                      <td style="font-size: 8pt; text-align: left;">
                        {{usuario.usuario.Perfil}}
                      </td>
                      <td style="text-align: -webkit-center;">
                        <table style="margin-top: -6px">
                          <tr>
                            <td>
                              <div class="badge"
                                style="font-size: 9pt; font-weight: bold; margin-right: 5px; background-color: '#827397'">
                                {{usuario.tareasXUsuario.TareasNuevasTotal}}
                              </div>
                            </td>
                            <td>
                              <a class="btn mr-1 btn-fab btn-secondary" (click)="verTareasNuevas(i)"
                                style="padding: 0px 3px; margin-left: -10px; font-size: 8pt"
                                *ngIf="!usuario.usuario.VerTareasNuevas && usuario.tareasXUsuario.TareasNuevasTotal > 0 && !usuario.usuario.VerTareasEnProceso && !usuario.usuario.VerTareasTerminadas">
                                <i class="fa fa-arrow-down"></i>
                              </a>

                              <a class="btn mr-1 btn-fab btn-success" (click)="ocultarTareasNuevas(i)"
                                style="padding: 0px 3px; margin-left: -10px; font-size: 8pt"
                                *ngIf="usuario.usuario.VerTareasNuevas && usuario.tareasXUsuario.TareasNuevasTotal > 0 && !usuario.usuario.VerTareasEnProceso && !usuario.usuario.VerTareasTerminadas">
                                <i class="fa fa-arrow-up"></i>
                              </a>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td style="text-align: -webkit-center;">
                        <table style="margin-top: -6px">
                          <tr>
                            <td>
                              <div class="badge"
                                style="font-size: 9pt; font-weight: bold; margin-right: 5px; background-color: '#4D4C7D'">
                                {{usuario.tareasXUsuario.TareasEnProcesoTotal}}
                              </div>
                            </td>
                            <td>
                              <a class="btn mr-1 btn-fab btn-secondary" (click)="verTareasEnProceso(i)"
                                style="padding: 0px 3px; margin-left: -10px; font-size: 8pt"
                                *ngIf="!usuario.usuario.VerTareasEnProceso && usuario.tareasXUsuario.TareasEnProcesoTotal > 0 && !usuario.usuario.VerTareasNuevas && !usuario.usuario.VerTareasTerminadas">
                                <i class="fa fa-arrow-down"></i>
                              </a>

                              <a class="btn mr-1 btn-fab btn-success" (click)="ocultarTareasEnProceso(i)"
                                style="padding: 0px 3px; margin-left: -10px; font-size: 8pt"
                                *ngIf="usuario.usuario.VerTareasEnProceso && usuario.tareasXUsuario.TareasEnProcesoTotal > 0 && !usuario.usuario.VerTareasNuevas && !usuario.usuario.VerTareasTerminadas">
                                <i class="fa fa-arrow-up"></i>
                              </a>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td style="text-align: -webkit-center;">
                        <table style="margin-top: -6px">
                          <tr>
                            <td>
                              <div class="badge"
                                style="font-size: 9pt; font-weight: bold; margin-right: 5px; background-color: '#363062'">
                                {{usuario.tareasXUsuario.TareasTerminadasTotal}}
                              </div>
                            </td>
                            <td>
                              <a class="btn mr-1 btn-fab btn-secondary" (click)="verTareasTerminadas(i)"
                                style="padding: 0px 3px; margin-left: -10px; font-size: 8pt"
                                *ngIf="!usuario.usuario.VerTareasTerminadas && usuario.tareasXUsuario.TareasTerminadasTotal > 0 && !usuario.usuario.VerTareasNuevas && !usuario.usuario.VerTareasEnProceso">
                                <i class="fa fa-arrow-down"></i>
                              </a>

                              <a class="btn mr-1 btn-fab btn-success" (click)="ocultarTareasTerminadas(i)"
                                style="padding: 0px 3px; margin-left: -10px; font-size: 8pt"
                                *ngIf="usuario.usuario.VerTareasTerminadas && usuario.tareasXUsuario.TareasTerminadasTotal > 0 && !usuario.usuario.VerTareasNuevas && !usuario.usuario.VerTareasEnProceso">
                                <i class="fa fa-arrow-up"></i>
                              </a>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <ng-container *ngIf="usuario.usuario.VerTareasNuevas">
                      <tr>
                        <td colspan="6">
                          <div style="height: 65vh; overflow-y: auto; margin-top: -5px;">
                            <table class="table table-responsive-md text-center">
                              <thead style="font-size: 10pt; text-align: left;">
                                <tr>
                                  <th>Fecha Creación</th>
                                  <th>Asignada Por</th>
                                  <th>Comparte con</th>
                                  <th>Prioridad</th>
                                  <th>Titulo</th>
                                  <th style="width: 250px">Detalle</th>
                                  <th>Notas y/o Documentos</th>
                                  <th>Opciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let tarea of usuario.tareasXUsuario.TareasNuevas; let i=index">
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.FechaRegistro | date:'dd/MM/yyyy'}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.UsuarioCreaTarea}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.UsuariosCompartenTarea}}
                                  </td>
                                  <td>
                                    <div class="badge" [ngClass]="{
                                        'bg-light-success': tarea.Prioridad == 'success',
                                        'bg-light-warning': tarea.Prioridad == 'warning',
                                        'bg-light-danger': tarea.Prioridad == 'danger'
                                      }" style="font-size: 8pt;">
                                      {{ tarea.Prioridad == 'success' ? 'Normal' : (tarea.Prioridad == 'warning' ?
                                      'Alta' : 'Urgente')}}
                                    </div>
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.TituloTarea}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.DescripcionTarea}}
                                  </td>
                                  <td>
                                    <div class="align-items-center" style="display: -webkit-inline-box!important">
                                      <div class="mr-2" (click)="abrirNotas(altaNotaTarea, tarea)"><i
                                          class="fas fa-comment-alt mr-1 cursor-pointer"></i>{{tarea.NumeroNotas}}</div>
                                      <div (click)="abrirDocumentos(altaDocumentosTarea, tarea)"><i
                                          class="fas fa-file-alt mr-1 cursor-pointer"></i>{{tarea.NumeroDocumentos}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <a class="primary" data-toggle="tooltip" style="margin-right: 5px"
                                      *ngIf="tarea.IdUsuarioCreaTarea == authService.usuarioConectado.Usuario.IdUsuario"
                                      data-placement="top" title="Editar"
                                      (click)="agregarOEditarTarea(altaActualizacionTareaAdministrador, tarea)">
                                      <i class="ft-edit font-medium-3"></i>
                                    </a>
                                    <a class="danger" data-toggle="tooltip"
                                      *ngIf="tarea.IdUsuarioCreaTarea == authService.usuarioConectado.Usuario.IdUsuario"
                                      data-placement="top" title="Deshabilitar">
                                      <i class="fas fa-trash font-medium-3"></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="usuario.usuario.VerTareasEnProceso">
                      <tr>
                        <td colspan="6">
                          <div style="height: 65vh; overflow-y: auto; margin-top: -5px;">
                            <table class="table table-responsive-md text-center">
                              <thead style="font-size: 10pt; text-align: left;">
                                <tr>
                                  <th>Fecha Creación</th>
                                  <th>Asignada Por</th>
                                  <th>Comparte con</th>
                                  <th>Titulo</th>
                                  <th>Detalle</th>
                                  <th>Notas y/o Documentos</th>
                                  <th>Opciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let tarea of usuario.tareasXUsuario.TareasEnProceso; let i=index">
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.FechaRegistro | date:'dd/MM/yyyy'}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.UsuarioCreaTarea}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.UsuariosCompartenTarea}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.TituloTarea}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.DescripcionTarea}}
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <div class="mr-2" (click)="abrirNotas(altaNotaTarea, tarea)"><i
                                          class="fas fa-comment-alt mr-1 cursor-pointer"></i>{{tarea.NumeroNotas}}</div>
                                      <div (click)="abrirDocumentos(altaDocumentosTarea, tarea)"><i
                                          class="fas fa-file-alt mr-1 cursor-pointer"></i>{{tarea.NumeroDocumentos}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <a class="primary" data-toggle="tooltip" style="margin-right: 5px"
                                      *ngIf="tarea.IdUsuarioCreaTarea == authService.usuarioConectado.Usuario.IdUsuario"
                                      data-placement="top" title="Editar"
                                      (click)="agregarOEditarTarea(altaActualizacionTareaAdministrador, tarea)">
                                      <i class="ft-edit font-medium-3"></i>
                                    </a>
                                    <a class="danger" data-toggle="tooltip"
                                      *ngIf="tarea.IdUsuarioCreaTarea == authService.usuarioConectado.Usuario.IdUsuario"
                                      data-placement="top" title="Deshabilitar">
                                      <i class="fas fa-trash font-medium-3"></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="usuario.usuario.VerTareasTerminadas">
                      <tr>
                        <td colspan="6">
                          <div style="height: 65vh; overflow-y: auto; margin-top: -5px;">
                            <table class="table table-responsive-md text-center">
                              <thead style="font-size: 10pt; text-align: left;">
                                <tr>
                                  <th>Fecha Creación</th>
                                  <th>Asignada Por</th>
                                  <th>Comparte con</th>
                                  <th>Titulo</th>
                                  <th>Detalle</th>
                                  <th>Notas y/o Documentos</th>
                                  <th>Fecha Termino</th>
                                  <th>Detalle Resolución</th>
                                  <th>Opciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let tarea of usuario.tareasXUsuario.TareasTerminadas; let i=index">
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.FechaRegistro | date:'dd/MM/yyyy'}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.UsuarioCreaTarea}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.UsuariosCompartenTarea}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.TituloTarea}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.DescripcionTarea}}
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <div class="mr-2" (click)="abrirNotas(altaNotaTarea, tarea)"><i
                                          class="fas fa-comment-alt mr-1 cursor-pointer"></i>{{tarea.NumeroNotas}}</div>
                                      <div (click)="abrirDocumentos(altaDocumentosTarea, tarea)"><i
                                          class="fas fa-file-alt mr-1 cursor-pointer"></i>{{tarea.NumeroDocumentos}}
                                      </div>
                                    </div>
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.FechaAtencion | date:'dd/MM/yyyy'}}
                                  </td>
                                  <td style="font-size: 8pt; text-align: left;">
                                    {{tarea.DescripcionResolucion}}
                                  </td>
                                  <td>
                                    <a class="primary" data-toggle="tooltip" style="margin-right: 5px"
                                      *ngIf="tarea.IdUsuarioCreaTarea == authService.usuarioConectado.Usuario.IdUsuario && tarea.Activo"
                                      data-placement="top" title="Editar"
                                      (click)="agregarOEditarTarea(altaActualizacionTareaAdministrador, tarea)">
                                      <i class="ft-edit font-medium-3"></i>
                                    </a>
                                    <a class="danger" data-toggle="tooltip" *ngIf="tarea.Activo" data-placement="top"
                                      title="Deshabilitar" (click)="actualizarTarea(tarea)">
                                      <i class="fas fa-trash font-medium-3"></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>